module.exports = __webpack_public_path__ + "static/media/canon.696e4497.jpg";